<template>

  <v-app id="inspire" >
    <!-- <v-app-bar app color="blue">
      <v-sheet>

      </v-sheet>
    </v-app-bar> -->
    <v-img 
    min-height="200"
    max-height="425"
    style="background-color: #3949ab !important;"
  :src="propertyInfo != undefined ? propertyInfo.bannerUrl : ''"
></v-img>
   
    <v-overlay :value="GetAjaxingRooms()">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-main class="grey lighten-3"
      :style="{ 'background-image': 'url(' + (propertyInfo != undefined ? propertyInfo.backgroundUrl : '') + ')', 'background-repeat': 'repeat' }">
      <v-container>
        <!-- THREE CONTAINER -->
        <v-row v-if="GetActiveScreen() !== 'addRoom'">
          <v-col lg="3" sm="12" md="12" xs="12" v-show="!GetAjaxingRooms()">
            <!-- <v-sheet rounded="lg" min-height="268">
            </v-sheet> -->
            <v-col justify="center" rounded="lg" min-height="268">
              <!-- <v-row class="mt-2 " justify="center"> -->
              <!-- <v-col md="6">
                <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                  transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" label="Arrival" persistent-hint
                      prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="startDateMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                  transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedEndDateFormatted" label="Departure" persistent-hint
                      prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" no-title @input="endDateMenu = false"></v-date-picker>
                </v-menu>
              </v-col> -->
              <v-col class="mb-0 pb-0">
                <v-row>
                  <v-col lg="8" md="8" sm="12">
                    <v-text-field v-model="promoCode" @change="onChangePromoCode" label="Promotion Code" solo light dense>
                    </v-text-field>

                  </v-col>
                  <v-col lg="4" md="4" sm="12">
                    <v-btn @click="searchRoomRatePlan" color="primary">
                      Apply
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col class="mt-0">
                <v-date-picker :min="currentDate" :max="maxDate" class="mt-0 pt-0" no-title full-width elevation="15" v-model="dates"
                  range>
                </v-date-picker>
                <!-- <search-component-vue></search-component-vue> -->
              </v-col>


              <!-- </v-row> -->
            </v-col>
            <v-sheet min-height="50vh" color="transparent">
              <property-information />
            </v-sheet>
          </v-col>

          <v-col v-if="GetActiveScreen() === 'room'" class="mx-auto" lg="6" xs="12" sm="12" md="12">
            <template v-show="!GetAjaxingRooms()">
              <v-sheet v-if="GetTimeoutErrorMessage()" min-height="10vh" rounded="lg">
                <v-container>
                  <v-col class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">
                    Session timeout, Please refresh the page.
                  </v-col>
                </v-container>
              </v-sheet>
              <v-sheet v-if="GetErrorMessage()" min-height="10vh" rounded="lg">
                <v-container>
                  <v-col class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">
                    {{GetErrorMessage()}}
                  </v-col>
                </v-container>
              </v-sheet>
              <v-tabs v-model="selectedTab">
                <v-tab>Room and Package ({{ rooms.length }})</v-tab>
                <v-tab v-if="roomPackages.length !== 0">Hot Deal ({{ totalPackages }})</v-tab>
              </v-tabs>
              <!-- Rooms Tab -->
              <v-sheet v-show="selectedTab === 0" min-height="70vh" rounded="lg">
                <!-- <v-row no-gutters> -->
                <v-col v-for="(item, iindex) in rooms" :key="iindex">
                  <room-card :room-rate="item" :key="iindex" @addRoom="addRoom">
                  </room-card>
                </v-col>
                <!-- </v-row> -->

                <!--  -->
              </v-sheet>
              <!-- Package Tab -->
              <v-sheet v-show="selectedTab === 1" min-height="70vh" rounded="lg">
                <!-- <v-row no-gutters> -->
                <v-col v-for="(item, iindex) in roomPackages" :key="iindex">
                  <package-card :room-rate="item" :key="iindex" @addRoom="addRoom">
                  </package-card>
                </v-col>
                <!-- </v-row> -->

                <!--  -->
              </v-sheet>
              <v-sheet min-height="30vh" rounded="lg">
                <policy-information></policy-information>
              </v-sheet>
            </template>
            <template v-if="GetAjaxingRooms()">
              <v-skeleton-loader type="card-avatar, article, actions"></v-skeleton-loader>
            </template>

          </v-col>
          <v-col v-if="GetActiveScreen() === 'bookingDetail'" class="mx-auto" lg="6" xs="12" sm="12" md="12">
            <!-- <v-sheet min-height="5vh" rounded="lg">
              <v-col>
                <booking-detail></booking-detail>
              </v-col>
            </v-sheet> -->
            <v-sheet class="mt-2" min-height="50vh" rounded="lg">
              <v-col>
                <payment-detail></payment-detail>
              </v-col>
            </v-sheet>
          </v-col>
          <v-col v-if="GetActiveScreen() === 'confirmation'" class="mx-auto" lg="6" xs="12" sm="12" md="12">
            <v-sheet min-height="60vh" rounded="lg">
              <v-col>
                <booked-details :OrderCode="OrderCode"></booked-details>
              </v-col>
            </v-sheet>
          </v-col>
          <v-col v-if="GetActiveScreen() === 'paymentFailed'" class="mx-auto" lg="6" xs="12" sm="12" md="12">
            <v-sheet min-height="60vh" rounded="lg">
              <v-col>
                {{errorDescription}}
              </v-col>
            </v-sheet>
          </v-col>


          <v-col lg="3" xs="12" sm="12" md="12" v-show="!GetAjaxingRooms()">
            <v-sheet id="id-booking-info" rounded="lg" min-height="268">
              <booking-info></booking-info>
            </v-sheet>
          </v-col>
        </v-row>



        <v-row v-if="GetActiveScreen() === 'addRoom'">
          <v-col xl="3" lg="3" sm="12" md="12" xs="12">
            <!-- <v-sheet rounded="lg" min-height="268"> </v-sheet> -->
            <!-- <search-component-vue></search-component-vue> -->
            <v-col class="mb-0 pb-0">
              <v-row>
                <v-col lg="8" md="8" sm="12">
                  <v-text-field v-model="promoCode" @change="onChangePromoCode" label="Promotion Code" solo light dense>
                  </v-text-field>

                </v-col>
                <v-col lg="4" md="4" sm="12">
                  <v-btn @click="searchRoomRatePlan" color="primary">
                    Apply
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col class="mt-0">
              <v-date-picker class="mt-0 pt-0" :min="currentDate" :max="maxDate" no-title full-width elevation="15" v-model="dates"
                range></v-date-picker>
              <!-- <search-component-vue></search-component-vue> -->
            </v-col>

          </v-col>
          <v-col xl="6" lg="6" xs="12" sm="12" md="12">
            <v-sheet min-height="60vh" rounded="lg">
              <v-col>
                <add-room></add-room>
              </v-col>
            </v-sheet>
          </v-col>
          <v-col xl="3" lg="3" xs="12" sm="12" md="12">
            <v-sheet id="id-summary-charge" v-if="GetRoomReserve() !== null" rounded="lg" min-height="268">
              <sub-summary-charge></sub-summary-charge>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>


    </v-main>
    <!-- <footer-component /> -->
  </v-app>

</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

import RoomCard from "../components/RoomRates/RoomCard.vue";
import PackageCard from "../components/RoomRates/PackageCard.vue";
import BookingInfo from "../components/Booking/BookingInfo.vue";
import BookingDetail from "../components/Booking/BookingDetail.vue";
import PaymentDetail from "../components/Booking/PaymentDetail.vue";
import BookedDetails from "../components/Booking/BookedDetails.vue";
import FooterComponent from "./Footer.vue";
import PolicyInformation from "./PolicyInformation.vue";
import PropertyInformation from "./PropertyInformation.vue"

import AddRoom from "../components/Charge/AddRoom.vue";
import SubSummaryCharge from "./Charge/SubSummaryCharge.vue";

import SearchComponentVue from "./SearchComponent.vue";
export default {
  props: {
    PropertyName: {
      type: String,
      require: true,
    },
    PropertyCode: {
      type: String,
      require: true,
    },
    Type: {
      type: String,
      required: false
    },
    OrderCode: {
      type: String,
      required: false
    }
  },
  components: {
    RoomCard,
    BookingInfo,
    BookingDetail,
    PaymentDetail,
    BookedDetails,
    AddRoom,
    SubSummaryCharge,
    PackageCard,
    SearchComponentVue,
    FooterComponent,
    PolicyInformation,
    PropertyInformation
  },
  data: () => ({
    links: ["Rooms", "Packages"],
    counter: 3,
    tempCounter: 0,
    selectedTab: 0,
    startDate: "2022-03-17",
    endDate: "2022-03-20",
    endDateMenu: false,
    startDateMenu: false,
    overlay: true,
    timeoutId: null,
    firstLoad: true,
    dates: [],
    currentDate: "",
    errorDescription: '',

    promoCode: "",
    previousPromoCode: "",
  }),
  methods: {
    addRoom: function (value, numberOfUnits) {
      let lengSelectedBooking = this.GetBookingInfo().length;

      for (let counter = 1; counter <= numberOfUnits; counter++) {
        this.$store.dispatch("addBookingInfo", {
          ...value,
          bookingNo: lengSelectedBooking + counter,
        });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    searchRoomRatePlan: function () {

      if(this.previousPromoCode != this.promoCode){
        this.$store.dispatch('clearRoomReserves');
      }

      let dates = _.sortBy(this.dates, o => o);
      const model = {
        startDate: dates[0],
        endDate: dates[1],
        promoCode: this.promoCode
      };
      this.$store.dispatch("getRoomTypeAvailabilityAndRates", model);

      this.$store.dispatch('setActiveScreen', 'room');

      this.$store.commit('setBookedDetails', null);

      this.previousPromoCode = _.cloneDeep(this.promoCode);

      if (this.$route.name !== 'Booking') {
      let internal = this.isInternal ? 'internal=1' : '';

        this.$router.push(`/Booking/webreservation/${this.PropertyCode}?${internal}`);
      }
      if (this.firstLoad)
        this.firstLoad = false;


    },
    setchange: function () {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.setTimeoutEvent();
      } else {
        this.setTimeoutEvent();
      }

    },
    setTimeoutEvent: function () {
      this.timeoutId = setTimeout(() => {
        console.log('stop change in one seconds')
      }, 1000)
    },
    onChangePromoCode: function () {
      this.promoCode = this.promoCode.trim();
    }
  },
  beforeMount: function () {
    this.$store.dispatch("setPropertyCode", this.PropertyCode);
  },
  mounted: function () {

    document.title = 'Booking';
    this.firstLoad = true;
    this.currentDate = moment().format('YYYY-MM-DD');
    this.startDate = moment().format('YYYY-MM-DD');
    this.dates.push(this.startDate);
    let today = new Date();

    today.setDate(today.getDate() + 1);
    this.endDate = moment(today).format('YYYY-MM-DD');
    this.dates.push(this.endDate);
    if (this.$route.name === 'Booking') {
      this.searchRoomRatePlan();
    }

    if (this.Type === 'Confirmation') {
      this.$store.dispatch('setActiveScreen', 'confirmation');
    } else if (this.Type === 'PaymentFailed') {
      this.errorDescription = this.$route.query.errorDescription;
      this.$store.dispatch('setActiveScreen', 'paymentFailed');
    }
    this.$store.dispatch("getPropertyInformation", null);


    this.$store.dispatch("getExtraService");
    this.$store.dispatch('fetchCountries');



  },
  computed: {
    ...mapGetters(["GetRooms",
      "GetBookingInfo",
      "GetActiveScreen",
      "GetAjaxingRooms",
      'GetRoomReserve',
      'GetBookingPolicy',
      'GetPropertyInfo',
      'GetTimeoutErrorMessage',
      'GetErrorMessage']),
    rooms: function () {
      return _.sortBy(this.GetRooms().filter((r) => {
        return (
          !r.isPackage
        );
      }).map((item) => { return { ...item, totalPrice: item.roomRatePlans[0].totalPrice } }), o => o.totalPrice);
    },
    roomPackages: function () {
      // return _.sortBy(this.GetRooms().filter((r) => {
      //   return (
      //     r.isPackage
      //   );
      // }).map((item) => { return { ...item, totalPrice: item.roomRatePlans[0].totalPrice } }), o => o.totalPrice);
      let listPackage = [];
      let list = _.sortBy(this.GetRooms().filter((r) => {
        return (
          r.isPackage
        );
      }).map((item) => { return { ...item, totalPrice: item.roomRatePlans[0].totalPrice } }), o => o.totalPrice);

      let listIds = [];
      list.map(x => {
        x.roomRatePlans.map(r => {
          listIds.push(r.hotDealId);
        })
      })


      listIds = [...new Set(listIds)];

      for (let count = 0; count < listIds.length; count++) {
        let id = listIds[count];
        let rates = [];
        let hotDealName = '';
        let hotDealDescription = '';
        let roomImages = [];
        list.map(m => {


          m.roomRatePlans.map(r => {
            if (r.hotDealId === id) {
              hotDealName = r.hotDealName;
              hotDealDescription = r.hotDealDescription;
              rates.push({ ...r, room: { ...m, roomRatePlans: null } });
              roomImages = r.roomImages;
            }
          })
        })
        let listSorted = _.sortBy(rates, o => o.totalPrice);
        listPackage.push({ roomRatePlans: listSorted, hotDealDescription, hotDealName, roomImages, totalPrice: listSorted[0].totalPrice })

      }


      return listPackage;

    },
    computedDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedEndDateFormatted() {
      return this.formatDate(this.endDate);
    },
    totalPackages: function () {
      if (this.roomPackages === null || this.roomPackages === undefined)
        return 0;


      return this.roomPackages.length;

    },
    propertyInfo: function () {
      return this.GetPropertyInfo();
    },
    isInternal: function () {
      let internal = this.$route.query.internal;

      if (internal === undefined)
        return false;

      if (internal === '1' || internal === 1)
        return true;

      return false;

    },
    maxDate: function(){
      let today = new Date();

    today.setFullYear(today.getFullYear() + 1);
    const maxDate = moment(today).format('YYYY-MM-DD');

    return maxDate;
    }
  },
  watch: {
    Type: function () {
      if (this.Type === 'Confirmation') {
        this.$store.dispatch('setActiveScreen', 'confirmation');
      }
      else if (this.Type === 'PaymentFailed') {
        this.errorDescription = this.$route.query.errorDescription;
        this.$store.dispatch('setActiveScreen', 'paymentFailed');
      }
    },
    dates: function () {
      if (this.dates.length === 2) {
        if (this.$route.name === 'Booking') {
          this.searchRoomRatePlan();
        }
      }

    },
    propertyInfo: function () {
      if (this.propertyInfo) {
        document.title = `Booking - ${this.propertyInfo.name}`;
        document.body.style.backgroundImage = `url(${this.propertyInfo.backgroundUrl})`;
      }

    }
  }
};
</script>


<style>
/* div#id-booking-info.v-sheet.theme--light.rounded-lg,
div#id-summary-charge.v-sheet.theme--light.rounded-lg {
  position: sticky !important;
  top: 130px !important
} */
</style>